import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { loadUserSession } from './actions/shared.actions';

@Injectable()
export class StateFacade {
  constructor(private readonly store: Store) {}

  init() {
    this.store.dispatch(loadUserSession());
  }
}
